<template>
  <div>
  </div>
</template>
<script>
export default {
  name: 'AppHome',

  mounted () {
    window.location.href = 'https://ar-email.com.br'
  }
}
</script>



// WEBPACK FOOTER //
// src/app/home/Home.vue